import request from './request'

// 获取当前学年
export const getCurrentAcademicYear = () => {
  return request.get('/academic-year/current/')
}

// 获取学年选项列表
export const getAcademicYears = () => {
  return request.get('/academic-year/options/')
}

// 获取全量班级列表
export const getAllClasses = (params = {}) => {
  return request.get('/academic/classes', { params })
}

// 获取我的任教班级
export const getMyClasses = (params = {}) => {
  return request.get('/academic/classes/my/', { params })
}

// 搜索学生
export const searchStudents = (params = {}) => {
  return request.get('/academic/students/', { params })
}

// 获取班级学生
export const getClassStudents = (classId) => {
  return request.get(`/academic/classes/${classId}/students`)
}


